import React from 'react'
import {connect} from 'react-redux'
import i18n from 'lib/i18n'
import styles from './b2bCompany.scss'
import BrokerSelector from '../BrokerSelector'
import {fetchB2bCompanyBrokers, fetchB2bCompanyClients, setB2bCompanyOpened, setB2bCompanySubModule, setB2bCompanyBrNr,
    initializeProfileForm, fetchClientOptionsDict, toggleModalClientProfileForm, setAppModule} from 'state/actions'
import B2bCompanySearchClientsForm from './b2bCompanySearchClientsForm'
import B2bCompanyClientResults from './b2bCompanyClientResults'
import B2bCompanyClientZoom from './b2bCompanyClientZoom'
import underscore from 'underscore'
import c from 'state/constants'

const _ = i18n('b2bCompany')

@connect((state) => {
	const currentBrNr = state.b2bCompany.brNr
    const clientAccess = state.app.security.actions
    let canCreateClient,canUpdateClient

    clientAccess.map((item, key) => {
        if (item.actionName == 'createclient') {
            canCreateClient = item.actionAllowed === "true" ? true : false
        }

        if (item.actionName == 'modifyclient') {
            canUpdateClient = item.actionAllowed === "true" ? true: false
        }
    })

	return {
		data: state.b2bCompany.data,
		opened: state.b2bCompany.opened,
		brokers: state.b2bCompany.brokers,
		currentBrNr,
        createClientAccess: canCreateClient,
        updateClientAccess: canUpdateClient,
        initializeProfileForm,
        toggleModalClientProfileForm,
		modalState: state.clientProfileForm.clientModal,
		b2bInsuranceCompany: state.b2b.b2bInsuranceCompany,
	}
})
export default class B2bCompany extends React.Component {
	static propTypes = {
		dispatch: React.PropTypes.func.isRequired,
		brokers: React.PropTypes.object.isRequired,
		currentBrNr: React.PropTypes.string,
		data: React.PropTypes.array,
		opened: React.PropTypes.string,
	}
	handleSearch = data => this.props.dispatch(fetchB2bCompanyClients(data))

    constructor(props) {
        super(props)
        this.state = {modalIsOpen: false}
    }

    componentDidMount() {
        const {dispatch} = this.props
		dispatch(fetchB2bCompanyBrokers())
	}

    componentWillMount() {
        const {dispatch, initializeProfileForm} = this.props
        dispatch(fetchClientOptionsDict())
    }

    shouldComponentUpdate(nextProps, nextState) {
        // missing require values from store then redirect to home
        this.goHomeIfRefresh( nextProps )
        return true
    }

    /**
     * This gonna redirect to the home screen when you do a refresh and loos all of the store.
     * This function will deprecated when we solve the store save when refresh.
     */
    goHomeIfRefresh = nextProps => {
        const {dispatch} = this.props
        if ( underscore.isEmpty(nextProps) ||
            underscore.isEmpty(nextProps.b2bInsuranceCompany) ||
            underscore.isEmpty(nextProps.b2bInsuranceCompany.companyId)
        ) {
            dispatch(setAppModule(''))
        }
    }

	zoomClient = id => {
		const {dispatch} = this.props
		dispatch(setB2bCompanyOpened(id))
		dispatch(setB2bCompanySubModule())
	}

    openModal(e) {
        e.preventDefault()
        const { dispatch, initializeProfileForm, toggleModalClientProfileForm, modalState } = this.props

        dispatch(toggleModalClientProfileForm(!modalState))
        dispatch(initializeProfileForm({}, null, 'create'))
    }

	render() {
		const {data, currentBrNr, brokers, opened, clientId, createClientAccess, updateClientAccess, modalState, b2bInsuranceCompany} = this.props

        const openModal = (e) => {
            this.openModal(e)
        }

		return (
			<div id={`${styles.b2bCompanyModule}`}>
				<div className={`${styles.b2bCompany}`}>
					<div className={`${styles.mainTitleDiv}`}>
						<div className={`${styles.mainTitleContainer}`}>
							<h2 className={`${styles.mainTitle}`}>
								{b2bInsuranceCompany && b2bInsuranceCompany.insuranceCompany || _('insuranceCompany')}
							</h2>
							<h3>{_('b2bCompanySubtitle')}</h3>
						</div>
					</div>
					<div id={`${styles.Navigation}`} className={`${styles.clientsSearchContainer} ${opened ? styles.hidden : 'visible'}`}>
						<div className={styles.brokerSelectorContainer}>
							<div className={styles.column}>
								<div className={styles.brokerSelectorContent}>
									<div className={styles.label}>
										{_('selectBroker')}
									</div>
									<div className = {styles.brokerSelectorContainer}>
										<BrokerSelector
											brokers = {brokers}
											setBrNr = {setB2bCompanyBrNr}
											brNr = {currentBrNr}
											customClass = {styles.brokerSelector}
										/>
									</div>
								</div>
								<div className = {styles.searchSubSubTitle }>{_('subSubTitle')}</div>
							</div>
							<div className={styles.column}>
							</div>
						</div>
						<B2bCompanySearchClientsForm
                            {...{
                                createClientAccess,
                                updateClientAccess,
                                openModal,
                                modalState
                            }}
							onSubmit={this.handleSearch}
							initialValues={{state: ''}}/>
						{data &&
							<B2bCompanyClientResults
								data={data}
								zoomTo={this.zoomClient}
							/>
						}
					</div>
					{opened && <B2bCompanyClientZoom/>}
				</div>
			</div>
		)}
	}



// WEBPACK FOOTER //
// ./components/b2bCompany/index.jsx